import React from 'react'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'

const currencyChipStyle = {
    backgroundColor:'#e3f2fd',
    color:'#1565c0',
    borderRadius:'4px',
    padding:'2px 6px',
    fontSize:'0.75rem',
    fontWeight:600,
    marginRight:'8px'
}

export const CurrencyAmount = ({ currency, amount }) => {
    if (!currency) return null
    return (
        <>
            <span style={currencyChipStyle}>{currency}</span>
            {numberFormatterWithDecimalAndThousand(amount)}
        </>
    )
}